import gsap from 'gsap';
import * as THREE from 'three';
import { Params } from '../data/Params';
import { ReverseObj } from './ReverseObj';
import { Formation } from './Formation';
import { Vector3 } from 'three';
import { FormationData } from './FormationData';


export class ReverseObjs extends THREE.Object3D{

    objects:ReverseObj[];
    cam:THREE.PerspectiveCamera;
    container:THREE.Object3D;

    colorId:number=0;
    numX:number=0;
    numY:number=0;
    rotSpd:THREE.Vector3 = new THREE.Vector3(0,0,0)
    rot:THREE.Vector3 = new THREE.Vector3(0,0,0)
    isRotX:boolean=false;

    constructor(cam:THREE.PerspectiveCamera){
    
      super();

      this.container = new THREE.Object3D();
      this.add(this.container);
      
      this.objects=[];

      this.colorId = Math.floor(Params.random()*10 );
      
      this.numX = 4;// + Math.floor(Params.random()*7);
      this.numY = 4;// + Math.floor(Params.random()*2);

      let amp = Params.random()<0.5 ? 0.4 : 0.5;
      let spaceY = 0.4;
      let idx = 0;
      
      for (let j = 0; j<this.numY; j++) {
        for(let i=0;i<this.numX; i++){

          let mesh = new ReverseObj();
          mesh.visible = false;          
          this.container.add(mesh);
          this.objects.push(mesh);
          
        }
      }

      this.cam = cam;

      Params.gui.add(this,"change");
      this.first();
      
    }

    first(){
      
      let data = FormationData.list[Params.formationId];
      let xx = data.numX
      let yy = data.numY;
      let amp = data.amp;      
      let ss = Params.getFirstSize();
      this.tweenForm(xx,yy,amp,ss,0);

      let isZ = Params.random()<0.3 ? true : false;
      this.rot.z = isZ ? Math.PI/2 : 0;
      this.rotation.z=this.rot.z;
      
      Params.preview();

      setTimeout(()=>{
        this.tweenRotation(true,isZ);
      },500);

    }

    
    change(data:FormationData,duration:number){

      let xx = data.numX
      let yy = data.numY;
      let amp = 0.3 + 0.3 * Params.random();//random度
      if(Params.random()<0.1){
        amp = 0.5 + 0.2 * Params.random();
      }
      let ss:number = Params.getRandomSize();
      this.tweenForm(xx,yy,amp,ss,duration);
      
    }


    tweenForm(xx:number,yy:number,amp:number,ss:number,duration:number=0){
      
      //フォーメーション

      //random
      for(let i=0;i<this.objects.length;i++){
        let idxA = Math.floor(Math.random()*this.objects.length);
        let idxB = Math.floor(Math.random()*this.objects.length);
        let tmp = this.objects[idxA]
        this.objects[idxA]=this.objects[idxB];
        this.objects[idxB]=tmp;
      }

      let offsetRad = Params.random()<0.5 ? Math.PI : 0;

      for(let i=0;i<this.objects.length;i++){
        let idx = i % (xx*yy);
        let p:Vector3 = Formation.getPoint(idx,xx,yy,amp,offsetRad);
        this.objects[i].visible=true;
        this.objects[i].tween(duration,p,ss);
      }

    }


    tweenRotation(isY:boolean=true,isZ:boolean=false){

      let tgtX = this.rot.x;
      let tgtY = this.rot.y;
      let tgtZ = this.rot.z;

      if(isY){
        tgtY+=Math.PI*4;
      }else{
        tgtX+=Math.PI*4;
      }
      
      if(isZ) tgtZ=Math.PI/2;
      else tgtZ=0;

      gsap.to(this.rot,{
        duration:2,
        z:tgtZ,
        ease:"Power2.easeInOut"
      });

      gsap.to(this.rot,{
        x:tgtX,
        y:tgtY,
        ease:"linear",
        duration:Params.interval,
        onComplete:()=>{
          this.onTweenRotation();      
        }
      });

    }

    onTweenRotation(){

      let isY = Math.random()<0.5 ? true : false;
      let isZ = Math.random()<0.2 ? true : false;
      this.tweenRotation( isY, isZ );
      this.change(
        FormationData.list[Math.floor(FormationData.list.length*Math.random())],
        Params.duration
      );
    }


    update(){
      
      this.rotation.x += ( this.rot.x - this.rotation.x )/40;
      this.rotation.y += ( this.rot.y - this.rotation.y )/40;
      this.rotation.z += ( this.rot.z - this.rotation.z )/40;
      
      //this.rotation.x+=0.01;
      //this.container.rotation.x += this.rotSpd.x;
      //this.container.rotation.y += this.rotSpd.y;
      //this.rotation.x+=0.03;

      for(let i=0;i<this.objects.length;i++){
        
        this.objects[i].update();

      }
    }

}